import React from 'react';
import { APP_VERSION } from '@/config/env';
import { cn } from '@/utils/cn';

/**
 * Shows the deployed app version from REACT_APP_VERSION (set at build time).
 */
export function AppVersionLabel({ className, variant = 'subtle', align = 'start', short = false }) {
  if (!APP_VERSION) return null;

  const label = short ? `v${APP_VERSION}` : `Version ${APP_VERSION}`;

  return (
    <p
      className={cn(
        'text-[10px] font-bold uppercase tracking-wider text-slate-400',
        align === 'center' && 'text-center',
        align === 'end' && 'text-right',
        variant === 'badge' &&
          'inline-flex rounded-full bg-slate-100 px-2.5 py-1 text-[11px] font-semibold normal-case tracking-normal text-slate-600',
        className
      )}
      title={`App version ${APP_VERSION}`}
    >
      {label}
    </p>
  );
}
